import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as pdfjsLib from 'pdfjs-dist';

// Configurazione PDF.js - worker CDN per evitare problemi MIME type
// Usa CDN con versione disponibile (3.11.174) - funziona indipendentemente dal server
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
